import { useNetwork } from '../providers/NetworkProvider';
import { __ } from '../utils';
import { Stack, type StackProps, Tooltip } from '@presov.sk/presov-ui-react';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import React from 'react';

type Props = {
  size?: number;
} & StackProps;

const MissingInternetConnectionIndicator: React.FC<Props> = ({
  size = 36,
  sx,
  ...stackProps
}) => {
  const { isOnline } = useNetwork();

  const getTooltipText = () => {
    if (!isOnline) {
      return __('Momentálne nie ste pripojený k internetu.');
    }
    return undefined;
  };

  if (isOnline) {
    return null;
  }

  return (
    <Tooltip title={getTooltipText()}>
      <Stack
        sx={{
          height: size,
          width: size,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => theme.palette.warning.main,
          borderRadius: '100%',
          cursor: 'help',
          ...sx,
        }}
        {...stackProps}
      >
        <WifiOffIcon sx={{ color: 'white', fontSize: size - 16 }} />
      </Stack>
    </Tooltip>
  );
};

export default MissingInternetConnectionIndicator;
